module.exports = __webpack_public_path__ + "0c85ca117602e93aea6bdf060d6f63d6.pdf";